import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, computed, inject, input, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { CloudinaryMediaTransformationBuilder, GenerateCloudinaryTransformationsRequest } from '@common/cloudinary/shared';
import { MediaAssetProvidersFrontendService } from '@common/media/frontend-shared';
import { MediaTransformationsRegistry } from '@common/media/shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiIconsModule } from '@common/ui/frontend-shared/icons';
import { UiLoadingIndicatorComponent } from '@common/ui/frontend-shared/loading-indicator';
import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { AppMessageFactory, AppRequestService, LocalMessageHandlerService, takeWhileAlive } from '@core/frontend-shared';
import { catchError, combineLatest, distinctUntilChanged, from, map, of, switchMap, throwError } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@common/media/shared";
import * as i3 from "../../../../ui/frontend-shared/src/lib/icons/icon.component";
import * as i4 from "@angular/common";
const _forTrack0 = ($index, $item) => $item.key;
function CloudinaryTransformationsComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message", 0);
    i0.ɵɵelement(1, "ui-icon", 2);
    i0.ɵɵtext(2, " Das Asset befindet sich noch in Verarbeitung. ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("showIcon", false);
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Fehler: ", ctx_r0.resourceError(), " ");
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 6);
    i0.ɵɵtext(1, " Transformierungen werden erstellt. Dies kann einige Minuten dauern. Das Fenster kann geschlossen werden. ");
    i0.ɵɵelementEnd();
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "(keine Transformierungen in Preset definiert)");
    i0.ɵɵelementEnd();
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "ui-icon", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const transformation_r2 = ctx.$implicit;
    i0.ɵɵproperty("title", "Transformierung '" + transformation_r2.value.clTransformationString + "' \u00F6ffnen")("href", transformation_r2.value.matchedResource == null ? null : transformation_r2.value.matchedResource.secure_url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", transformation_r2.key, " ");
    i0.ɵɵadvance();
    i0.ɵɵclassMap(transformation_r2.value.matchedResource ? "color-success" : "color-danger");
    i0.ɵɵproperty("icon", transformation_r2.value.matchedResource ? "check" : "times");
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_Conditional_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const preset_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.generateMissingTransformations(preset_r4));
    });
    i0.ɵɵelementEnd();
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 9);
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 10);
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵconditionalCreate(1, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_Conditional_1_Template, 2, 0, "span");
    i0.ɵɵrepeaterCreate(2, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_For_3_Template, 3, 6, "a", 7, _forTrack0);
    i0.ɵɵpipe(4, "keyvalue");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵconditionalCreate(6, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_Conditional_6_Template, 1, 0, "button", 8);
    i0.ɵɵconditionalCreate(7, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_Conditional_7_Template, 1, 0, "ui-icon", 9);
    i0.ɵɵconditionalCreate(8, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_Conditional_8_Template, 1, 0, "ui-icon", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const preset_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(preset_r4.transformations.size === 0 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(4, 4, preset_r4.transformations));
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(!preset_r4.allAvailable ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(preset_r4.required && preset_r4.allAvailable ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(preset_r4.required && !preset_r4.allAvailable ? 8 : -1);
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_3_Template, 2, 0, "td", 6)(4, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Conditional_4_Template, 9, 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const preset_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", preset_r4.name, "\u00A0 ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(preset_r4.transformationRunning ? 3 : 4);
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " (keine vorhanden) ");
    i0.ɵɵelementEnd();
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 4)(2, "table", 5)(3, "thead")(4, "th");
    i0.ɵɵtext(5, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th");
    i0.ɵɵtext(7, "Transformierungen");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "tbody");
    i0.ɵɵrepeaterCreate(11, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_For_12_Template, 5, 2, "tr", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(13, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_Conditional_13_Template, 2, 0, "div");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_4_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(11);
    i0.ɵɵrepeater(ctx_r0.transformationPresetsWithStatus());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!((tmp_4_0 = ctx_r0.transformationPresetsWithStatus()) == null ? null : tmp_4_0.length) ? 13 : -1);
  }
}
function CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_0_Template, 2, 1, "ui-message", 3)(1, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Conditional_1_Template, 14, 1, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.resourceError() ? 0 : 1);
  }
}
function CloudinaryTransformationsComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-loading-indicator", 1);
    i0.ɵɵtemplate(1, CloudinaryTransformationsComponent_Conditional_3_ng_template_1_Template, 2, 1, "ng-template");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", !ctx_r0.loaded());
  }
}
export let CloudinaryTransformationsComponent = /*#__PURE__*/(() => {
  class CloudinaryTransformationsComponent {
    constructor(apiService, messages, cd, mediaTransformations) {
      this.apiService = apiService;
      this.messages = messages;
      this.cd = cd;
      this.mediaTransformations = mediaTransformations;
      this.mediaAsset = input.required(...(ngDevMode ? [{
        debugName: "mediaAsset"
      }] : /* istanbul ignore next */[]));
      this.assetIsReady = computed(() => this.mediaAsset()?.ready, ...(ngDevMode ? [{
        debugName: "assetIsReady"
      }] : /* istanbul ignore next */[]));
      this.loaded = signal(false, ...(ngDevMode ? [{
        debugName: "loaded"
      }] : /* istanbul ignore next */[]));
      this.resource = signal(null, ...(ngDevMode ? [{
        debugName: "resource"
      }] : /* istanbul ignore next */[]));
      this.resourceError = signal(null, ...(ngDevMode ? [{
        debugName: "resourceError"
      }] : /* istanbul ignore next */[]));
      this.providers = inject(MediaAssetProvidersFrontendService);
      this.transformationPresets = computed(() => {
        const item = this.mediaAsset();
        return this.mediaTransformations.getAllPresetsForType(item.type);
      }, ...(ngDevMode ? [{
        debugName: "transformationPresets"
      }] : /* istanbul ignore next */[]));
      this._reload = combineLatest({
        asset: toObservable(this.mediaAsset).pipe(distinctUntilChanged((a, b) => {
          return a.id === b.id;
        })),
        ready: toObservable(this.assetIsReady)
      }).pipe(takeWhileAlive(), switchMap(({
        asset,
        ready
      }) => {
        if (!asset || !asset.providerData) {
          return throwError(() => "Ungültige Daten in MediaAssetItem");
        }
        const provider = this.providers.getProvider(asset);
        this.loaded.set(false);
        if (!ready) {
          return of(null);
        }
        return from(provider.getAssetDetails(asset, {
          withRawData: true,
          withDerived: true
        })).pipe(map(response => {
          this.resource.set(response.raw);
          this.resourceError.set(null);
          this.loaded.set(true);
          this.cd.detectChanges();
        }), catchError(error => {
          if (error.status === 422) {
            error.discard();
            this.resource.set(null);
            return throwError(() => error.message);
          }
          return throwError(() => error);
        }));
      })).subscribe({
        next: () => {},
        error: err => {
          this.resourceError.set(err);
          this.loaded.set(true);
          this.cd.detectChanges();
        }
      });
      this.transformationPresetsWithStatus = computed(() => {
        const resource = this.resource();
        const presets = this.transformationPresets();
        if (!resource || !presets?.length) return [];
        return presets.map(original => {
          const preset = {
            ...original
          };
          let allAvailable = true;
          preset.transformations.forEach(transf => {
            transf.clTransformationString = CloudinaryMediaTransformationBuilder.toUrlString(transf.transformation);
            // console.log('match cloudinary transformation with available', transf, resource.derived)
            transf.matchedResource = resource.derived.find(derived => derived.transformation === transf.clTransformationString);
            if (!transf.matchedResource) allAvailable = false;
          });
          preset.allAvailable = allAvailable;
          // preset.required = this.requiredClPresets.includes(preset.name);
          preset.transformationRunning = false;
          return preset;
        });
      }, ...(ngDevMode ? [{
        debugName: "transformationPresetsWithStatus"
      }] : /* istanbul ignore next */[]));
    }
    generateMissingTransformations(preset) {
      const missingTransforms = [];
      preset.transformations.forEach((transf, name) => {
        if (!transf.matchedResource) missingTransforms.push(transf);
      });
      this.apiService.sendRequest(GenerateCloudinaryTransformationsRequest, {
        transformations: missingTransforms.map(transf => transf.transformation),
        item: this.mediaAsset()
      }).subscribe(response => {
        preset.transformationRunning = true;
        this.cd.detectChanges();
      });
    }
    static {
      this.ɵfac = function CloudinaryTransformationsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CloudinaryTransformationsComponent)(i0.ɵɵdirectiveInject(i1.AppRequestService), i0.ɵɵdirectiveInject(i1.AppMessageFactory), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.MediaTransformationsRegistry));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CloudinaryTransformationsComponent,
        selectors: [["cloudinary-transformations"]],
        inputs: {
          mediaAsset: [1, "mediaAsset"]
        },
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService])],
        decls: 4,
        vars: 2,
        consts: [["type", "info", 3, "showIcon"], [3, "loading"], ["icon", "hourglass-half", "size", "lg"], ["type", "warn"], [1, "ui-margin"], [1, "ui-simpletable"], ["colspan", "2"], ["target", "_blank", 1, "transformation-tag", 3, "title", "href"], ["uiButton", "", "icon", "sync-alt", "title", "Fehlende Transformierungen starten", 1, "ui-button-contrast"], ["icon", "check", "size", "lg", "title", "Alle Transformierungen vorhanden!", 1, "color-success"], ["icon", "exclamation-triangle", "size", "lg", "title", "Erforderliche Transformierungen fehlen!", 1, "color-warning"], [3, "icon"], ["uiButton", "", "icon", "sync-alt", "title", "Fehlende Transformierungen starten", 1, "ui-button-contrast", 3, "click"]],
        template: function CloudinaryTransformationsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h3");
            i0.ɵɵtext(1, "Transformierungen verwalten");
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(2, CloudinaryTransformationsComponent_Conditional_2_Template, 3, 1, "ui-message", 0);
            i0.ɵɵconditionalCreate(3, CloudinaryTransformationsComponent_Conditional_3_Template, 2, 1, "ui-loading-indicator", 1);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.assetIsReady() ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.assetIsReady() ? 3 : -1);
          }
        },
        dependencies: [CommonModule, FormsModule, UiButtonComponent, UiIconsModule, i3.UiIconComponent, UiMessageComponent, UiLoadingIndicatorComponent, i4.KeyValuePipe],
        styles: ["table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:left}.transformation-tag[_ngcontent-%COMP%]{background:var(--softGreyColor);display:inline-block;padding:2px 4px;margin:0 6px 4px 0;color:var(--textColor)}.transformation-tag[href][_ngcontent-%COMP%]:hover{background:var(--secondaryColor);color:var(--secondaryTextColor)}"],
        changeDetection: 0
      });
    }
  }
  return CloudinaryTransformationsComponent;
})();